export default class Price_Slider {
    
    constructor(container, options){

        if( typeof container === 'string' ) {
            container = document.querySelector(container);
        }

        this.container = options.container;

        this.options = options;
        
        this.el_slider = container.querySelector('.slider');
        this.el_slider_value = container.querySelector('.slider_value');
        
        this.el_min = this.el_slider_value.querySelector('.min');
        this.el_max = this.el_slider_value.querySelector('.max');

        this.last_search = {
            min: 0,
            max: 0,
        };

        this.init();
    }

    init(){
    
        this.slider = noUiSlider.create(this.el_slider, {
            start: [this.options.min, this.options.max],
            connect: true,
            step: 10,
            range: {
                'min': this.options.min,
                'max': this.options.max,
            }
        })

        this.slider.on('update', (values)=>{
            this.update_value_text(values);
        })

        this.slider.on('set', (values)=>this.query(values));
    }

    update_value_text(values){
        this.el_min.textContent = parseInt(values[0]);
        this.el_max.textContent = parseInt(values[1]);
    }

    query(values){
        
        if( this.last_search.min == values[0] &&
            this.last_search.max == values[1] ) {
            return; // no change
        }

        this.last_search.min = values[0];
        this.last_search.max = values[1];

        const ff_ajax = this.options.ff_ajax;
        
        // price from
        ff_ajax.filters.update_filter('price_from', 'meta_query', {
            key: '_price',
            value: parseInt(values[0]),
            type: 'NUMERIC',
            compare: '>=',
        });
        
        // price to
        ff_ajax.filters.update_filter('price_to', 'meta_query', {
            key: '_price',
            value: parseInt(values[1]),
            type: 'NUMERIC',
            compare: '<=',
        });

        ff_ajax.filters.query();
    }
}